module ProcessEditor {
    export function draggableClick($parse: ng.IParseService): ng.IDirective {
        return {
            restrict: "A",
            scope: false,
            compile: function ($element, attr) {
                var fn = $parse(attr["draggableClick"]);
                return function ngEventHandler(scope, element) {
                    element.on("click", function(event) {
                        if (!element.data("hasBeenDragged")) {
                            var callback = function() {
                                fn(scope, { $event: event });
                            };
                            scope.$apply(callback);
                        }
                        element.data("hasBeenDragged", false);
                    });
                }
            }
        }
    }
    app.directive("draggableClick", ["$parse", draggableClick]);
}